import NextLink from 'next/link'
import styled from 'styled-components'

import { Section as SectionDS } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { media, space, sizes, fontSizes } = theme

type CardsWrapperProps = {
  readonly $variant: 'all' | 'desktop' | 'mobile'
}

export const Section = styled(SectionDS)`
  padding-top: ${space['spacing-xxxl']};
  padding-bottom: ${space['spacing-xxxl']};

  h2 {
    margin-bottom: ${space['spacing-sm']};
  }

  > div > div:nth-child(2) {
    overflow-x: auto;
  }

  @media (${media.tablet}) {
    padding-top: ${space['spacing-giga']};
    padding-bottom: ${space['spacing-giga']};

    h2,
    h2 > span {
      font-size: ${fontSizes['font-size-heading-2']};
    }
  }
`

export const CardsWrapper = styled.div<CardsWrapperProps>`
  display: ${({ $variant }) => ($variant === 'desktop' ? 'none' : 'flex')};
  gap: ${space['spacing-sm']};

  @media (${media.tablet}) {
    display: ${({ $variant }) => ($variant === 'mobile' ? 'none' : 'grid')};
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: ${space['spacing-md']};
  }
`

export const CardContent = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
  padding: ${space['spacing-sm']};

  svg {
    width: ${sizes['spacing-xxl']};
    height: ${sizes['spacing-xxl']};
  }

  @media (${media.tablet}) {
    h3 {
      font-size: ${fontSizes['font-size-heading-4']};
    }
  }
`

export const TitleLink = styled(NextLink)`
  color: inherit;
  text-decoration: none;
`
